module.exports = __webpack_public_path__ + "static/media/umerConferenceselect.bc63f0ef.png";